export const STATUS_STYLE = {
  pendente: { label: 'Pendente', dot: 'bg-red-500', badge: 'bg-red-100 text-red-800 border-red-200' },
  pronto_para_entrega: { label: 'Pronto para Entrega', dot: 'bg-green-500', badge: 'bg-green-100 text-green-800 border-green-200' },
  aguardando_conferencia: { label: 'Aguardando Conferência', dot: 'bg-yellow-500', badge: 'bg-yellow-100 text-yellow-800 border-yellow-200' },
  em_conferencia: { label: 'Em Conferência', dot: 'bg-blue-500', badge: 'bg-blue-100 text-blue-800 border-blue-200' },
  recebido: { label: 'Recebido e Conferido', dot: 'bg-emerald-600', badge: 'bg-emerald-100 text-emerald-800 border-emerald-200' },
  com_divergencia: { label: 'Com Divergência', dot: 'bg-orange-500', badge: 'bg-orange-100 text-orange-800 border-orange-200' },
  sem_pacientes: { label: 'Sem Pacientes', dot: 'bg-gray-400', badge: 'bg-gray-100 text-gray-600 border-gray-200' },
};

export const GUIA_STATUS = {
  nao_enviada: { label: 'Não enviada', cls: 'bg-red-100 text-red-800' },
  anexada: { label: 'Enviada', cls: 'bg-green-100 text-green-800' },
  entregue: { label: 'Aguardando conferência', cls: 'bg-yellow-100 text-yellow-800' },
  conferida: { label: 'Conferida', cls: 'bg-blue-100 text-blue-800' },
  divergencia: { label: 'Divergência', cls: 'bg-orange-100 text-orange-800' },
  recebida_conferida: { label: 'Recebida e Conferida', cls: 'bg-emerald-100 text-emerald-800' },
  devolvida: { label: 'Devolvida', cls: 'bg-red-100 text-red-800' },
};
export const VALIDACAO_STATUS = {
  pendente: { label: 'Pendente', cls: 'bg-yellow-100 text-yellow-800' },
  recebida: { label: 'Recebida', cls: 'bg-blue-100 text-blue-800' },
  aprovada: { label: 'Aprovada', cls: 'bg-emerald-100 text-emerald-800' },
  devolvida: { label: 'Devolvida', cls: 'bg-red-100 text-red-800' },
};

export const TIPO_DIVERGENCIA_LABELS = {
  guia_nao_apresentada: 'Guia não apresentada fisicamente',
  guia_ilegivel: 'Guia ilegível',
  guia_incompleta: 'Guia incompleta',
  guia_incorreta: 'Guia incorreta',
  guia_outro_paciente: 'Guia de outro paciente',
  dados_divergentes: 'Dados divergentes',
  guia_duplicada: 'Guia duplicada',
  documento_invalido: 'Documento inválido',
  paciente_sem_guia: 'Paciente sem guia',
  outra: 'Outra divergência',
};

export const fmtDate = (iso) => {
  if (!iso) return '-';
  const [y, m, d] = iso.slice(0, 10).split('-');
  return `${d}/${m}/${y}`;
};

export const fmtDateTime = (iso) => {
  if (!iso) return '-';
  return `${fmtDate(iso)} ${iso.slice(11, 16)}`;
};

export const errMsg = (e, fallback) => {
  const d = e?.response?.data?.detail;
  if (!d) return fallback;
  if (typeof d === 'string') return d;
  if (d.message) {
    const extra = ['esperadas', 'lancadas', 'pendentes', 'conferidas', 'inconsistentes', 'divergencias_abertas']
      .filter((k) => d[k] !== undefined).map((k) => `${k}: ${d[k]}`).join(', ');
    return extra ? `${d.message} (${extra})` : d.message;
  }
  return fallback;
};

// Compress images client-side (max 1600px, JPEG 0.82) to keep MongoDB light; PDFs pass through.
export const fileToDataUrl = (file) => new Promise((resolve, reject) => {
  const reader = new FileReader();
  reader.onerror = () => reject(new Error('Falha ao ler arquivo'));
  reader.onload = (ev) => {
    if (!file.type.startsWith('image/')) return resolve(ev.target.result);
    const img = new Image();
    img.onload = () => {
      const max = 1600;
      const scale = Math.min(1, max / Math.max(img.width, img.height));
      const canvas = document.createElement('canvas');
      canvas.width = Math.round(img.width * scale);
      canvas.height = Math.round(img.height * scale);
      canvas.getContext('2d').drawImage(img, 0, 0, canvas.width, canvas.height);
      resolve(canvas.toDataURL('image/jpeg', 0.82));
    };
    img.onerror = () => resolve(ev.target.result);
    img.src = ev.target.result;
  };
  reader.readAsDataURL(file);
});
